import { SvgBase } from "../svg.base";

export const Gift: React.FC<{ size?: number }> = ({ size }) => (
    <SvgBase
        width={"" + (size || 24)}
        height={"" + (size || 24)}
        viewBox="0 0 16 16"
    >
        <g fill="none" fillRule="evenodd">
            <g fill="currentColor" fillRule="nonzero">
                <g>
                    <g>
                        <g>
                            <path d="M9.941 2.29c.885-.511 2.005-.227 2.503.635.497.862.184 1.975-.701 2.485l.11-.071h1.484c.366 0 .663.305.663.68v1.708c0 .375-.297.68-.663.68l-.397-.001v3.59c0 1.037-.61 1.933-1.457 2L11.38 14H4.62c-.867 0-1.51-.856-1.557-1.88l-.003-.124-.001-3.59h-.396c-.366 0-.663-.304-.663-.68V6.02c0-.376.297-.68.663-.68l1.483-.001-.024-.014c-.78-.542-1.037-1.583-.566-2.4.498-.862 1.618-1.146 2.503-.636.454.262 1.079 1.006 1.94 2.279.863-1.273 1.488-2.017 1.942-2.279zM7.502 8.405H4.053v3.59c0 .536.259.932.516.979l.051.005 2.882-.001V8.406zm4.444 0H8.502v4.573h2.878c.256 0 .53-.362.563-.878l.003-.105v-3.59zM7.502 6.359H2.993v1.027h4.509V6.359zm5.504 0H8.502v1.027h4.504V6.36zM4.44 3.435c-.223.387-.083.886.314 1.115l.043.022c.261.125.883.24 1.83.329l.413.035-.236-.337c-.584-.823-1.01-1.315-1.242-1.449-.397-.229-.899-.101-1.122.285zm7.12 0c-.223-.386-.725-.514-1.122-.285-.26.15-.768.754-1.469 1.773l-.009.013.219-.017c1.056-.092 1.745-.214 2.024-.347l.043-.022c.397-.23.537-.728.314-1.115z" transform="translate(-633 -445) translate(532 437) translate(16 5) translate(85 3)" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </SvgBase>
);


